// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contentLayout{padding:25px}.contentLayout .contentHeader{display:flex;align-items:center}.contentLayout .contentHeader .backBtn{margin-right:5px}.contentLayout .contentHeader h1{margin:0}.contentLayout .headerDivider{margin:\"12\"}", ""]);
// Exports
module.exports = exports;
